import React from 'react';
import { motion } from 'framer-motion';
import { ChevronUp } from 'lucide-react';

const UpArrow = ({ onClick }) => (
  <motion.button
    onClick={onClick}
    className="fixed bottom-8 right-8 p-4 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-full border border-white/20 text-white/80 hover:text-white transition-colors duration-200 z-50"
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: 20 }}
    whileHover={{ scale: 1.1 }}
    whileTap={{ scale: 0.95 }}
  >
    <ChevronUp className="w-6 h-6" />
  </motion.button>
);

export default UpArrow;